import React from "react";

type ToastContextState = {
  showToast: (message: string, duration?: number) => void;
};

const ToastContext = React.createContext({} as ToastContextState);

export default ToastContext;
